var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"notifications-tracker",attrs:{"to":(_vm.n) ? '/user/notifications' : '/user'}},[(_vm.number)?_c('div',{staticClass:"red-div"},[_vm._v(" "+_vm._s(_vm.number)+" ")]):_vm._e(),_c('unicon',{attrs:{"name":"user"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }